import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "./ActiveTimeBattleCard.css";

const percentString = (value, round) => {
	return (round ? Math.round(value * 100) : value * 100) + "%";
}

const ActiveTimeBattleCard = (props) => {
	const data = props.characterData;
	const [name, setName] = useState(data.name || '');
	const [initiative, setInitiative] = useState(data.initiative);
	
	const placeholderProgress = data.currentPoints / data.maxPoints;
	const backgroundColor = data.currentPoints < data.maxPoints ? "#555" : "green";

	const handleNameChange = (e) => {
		setName(e.target.value);
	};

	const handleNameBlur = () => {
		if (props.onUpdate) {
			props.onUpdate(props.characterIndex, { name });
		}
	};

	const handleInitiativeChange = (e) => {
		const newInitiative = parseInt(e.target.value) || 0;
		setInitiative(newInitiative);
		if (props.onUpdate) {
			props.onUpdate(props.characterIndex, { initiative: newInitiative });
		}
	};

	return (
		<div className="ActiveTimeBattleCard" style={{ backgroundColor: backgroundColor }}>
			<button className="removeButton" onClick={() => props.onRemove(props.characterIndex)}>×</button>
			<div className="infoLine">
				<span className="nameInput">
				<input type="text" placeholder="Character name" value={name} onChange={handleNameChange} onBlur={handleNameBlur} />
				</span>
				<span className="initiativeInput">
					<label>Initiative: </label>
					<input type="number" min="1" max="30" value={initiative} onChange={handleInitiativeChange} />
				</span>
			<span className="turnsDisplay">Turns: {data.turns}</span>
			</div>
			<div className="progressBarContainer">
				<div className="progressBar">
					<div className="progressBarFill" style={{ width: percentString(placeholderProgress) }} />
				</div>
				<span className="progressLabel">{percentString(placeholderProgress, true)}</span>
			</div>
		</div>
	);
}

export default ActiveTimeBattleCard;
